import { Component } from '@angular/core';
// import { BaseComponent } from '../../../modules/tcm-core.module';
import { ActivatedRoute } from '@angular/router';
import { NoahSessionGraphViewModel } from '../../../models/noah-sessions/noah-session-graph-view-model';
import { NoahSessionGraphRequest } from '../../../models/noah-sessions/noah-session-graph-request';
import { EarSideEnum } from '../../../models/enums';
import { SecureBaseComponentContext } from '../../../modules/tcm-common/services/secure-base-component-context.service';
import { NoahSessionAudiogramViewModel } from '../../../models/noah-sessions';
import { BaseComponent } from '../../tcm-core.module/components/base-component/base-component.component';

@Component({
    selector: 'noah-audiogram-view',
    templateUrl: './noah-audiogram-view.component.html',
    styleUrls: ['./noah-audiogram-view.component.scss'],
    standalone: false
})
export class NoahAudiogramViewComponent
    extends BaseComponent<NoahSessionGraphRequest, NoahSessionAudiogramViewModel> {
    public leftSideEnumValue = EarSideEnum.Left;
    public rightSideEnumValue = EarSideEnum.Right;

    constructor(protected override componentContext: SecureBaseComponentContext,
        protected override route: ActivatedRoute) {
        super(componentContext, route);
        this.actionName = 'NoahSessions/GetNoahSessionGraph';
    }

    protected createRequestModel(): NoahSessionGraphRequest {
        return {} as NoahSessionGraphRequest;
    }
}
